const buildUrlLogin = (url: string, realm: string, clientId: string, redirectUri: string, state: string) => {
    return `${url}/realms/${realm}/protocol/openid-connect/auth?client_id=${clientId}&response_type=code&state=${state}&redirect_uri=${redirectUri}`;
}

export interface KeycloakConfigOptions {
    url: string
    realm: string
    redirectUri: string
    clientId: string
}

export class KeycloakService {
    private readonly url: string
    private readonly realm: string
    private readonly redirectUri: string
    private readonly clientId: string

    constructor(options: KeycloakConfigOptions) {
        this.url = options.url
        this.realm = options.realm
        this.redirectUri = options.redirectUri
        this.clientId = options.clientId
    }

    redirectToLogin = () => {
        let state = localStorage.getItem("kc_state")

        if (!state) {
            state = this.generateRandomState()
            localStorage.setItem("kc_state", state);
        }

        const url = buildUrlLogin(this.url, this.realm, this.clientId, this.redirectUri, state)
        window.location.replace(url);
    }

    checkValidState = (state: string) => {
        const storedState = localStorage.getItem("kc_state");

        return state === storedState;
    }

    generateRandomState = () => {
        const stateLength = 32; // Tamanho desejado do estado
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let state = "";

        for (let i = 0; i < stateLength; i++) {
            state += characters.charAt(Math.floor(Math.random() * characters.length));
        }

        return state;
    };
}

export function keycloakServiceFactory() {
    return new KeycloakService({
        url: process.env.KEYCLOAK_SERVER_URL!,
        realm: process.env.KEYCLOAK_REALM!,
        redirectUri: process.env.KEYCLOAK_REDIRECT_URI!,
        clientId: process.env.KEYCLOAK_CLIENT_ID!
    })
}
